import React from 'react';
import './ResidentsPage.css'
import {languageManager} from "../../utils/i18n";

const ResidentsPage = () => {
	const t = languageManager.t.bind(languageManager);

	return (
		<div className="residents_page">
			<div className="residents_container">
				{t('residents').map(({title, list}) =>
					<div className='residents_content' key={title}>
						<h2>{title}</h2>
						{list.map((item, index) => (
							<p key={index}>
								{item.link ? (
									<a href={item.link} target="_blank" rel="noopener noreferrer">
										{item.name}
									</a>
								) : (
									item.name
								)}
							</p>
						))}
					</div>
				)}
				<div className="residents_others residents_content">
					{t('residents.others').map(({name, about, link}) =>
						<div key={name}>
							<h3>
								{link ? (
									<a href={link} target="_blank" rel="noopener noreferrer">
										{name}
									</a>
								) : (
									name
								)}
							</h3>
							<span>{about}</span>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default ResidentsPage;